'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoubleOptin = function (_Resource) {
    (0, _inherits3.default)(DoubleOptin, _Resource);

    function DoubleOptin() {
        (0, _classCallCheck3.default)(this, DoubleOptin);
        return (0, _possibleConstructorReturn3.default)(this, (DoubleOptin.__proto__ || (0, _getPrototypeOf2.default)(DoubleOptin)).apply(this, arguments));
    }

    (0, _createClass3.default)(DoubleOptin, [{
        key: 'getForCurrentCustomer',


        /**
         * @api {get} /v1/ticket_applications getForCurrentCustomer
         * @apiGroup DoubleOptin
         * @apiName getForCurrentCustomer
         * @apiDescription Get all ticket applications that belong to current user.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.getForCurrentCustomer({...})
         */
        value: function getForCurrentCustomer(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/ticket_applications' + query);
        }

        /**
         * @api {get} /v1/customers/:customer_id/applications getForCustomer
         * @apiGroup DoubleOptin
         * @apiName getForCustomer
         * @apiDescription Get all ticket applications that belong to the querying customerID. Requires platform admin permssions.
         * @apiParam {Number} customer_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.getForCustomer({...})
         */

    }, {
        key: 'getForCustomer',
        value: function getForCustomer(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/customers/' + params.customer_id + '/applications' + query);
        }

        /**
         * @api {get} /v1/customers/:customer_id/applications/:ticket_id get
         * @apiGroup DoubleOptin
         * @apiName get
         * @apiDescription Get all candidates applying for this ticket.
         * @apiParam {Number} customer_id
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/customers/' + params.customer_id + '/applications/' + params.ticket_id);
        }

        /**
         * @api {} DELETE /v1/tickets/:ticket_id/applicants remove
         * @apiGroup DoubleOptin
         * @apiName remove
         * @apiDescription Cancel the current users application for a ticket.
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.remove({...})
         */

    }, {
        key: 'remove',
        value: function remove(params) {
            return this.client.delete('/v1/tickets/' + params.ticket_id + '/applicants');
        }

        /**
         * @api {get} /v1/tickets/:ticket_id/applicants getAll
         * @apiGroup DoubleOptin
         * @apiName getAll
         * @apiDescription Get all candidates applying for this ticket.
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.getAll({...})
         */

    }, {
        key: 'getAll',
        value: function getAll(params) {
            return this.client.get('/v1/tickets/' + params.ticket_id + '/applicants');
        }

        /**
         * @api {post} /v1/tickets/:ticket_id/applicants apply
         * @apiGroup DoubleOptin
         * @apiName apply
         * @apiDescription Apply for a ticket with the current user.
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.apply({...})
         */

    }, {
        key: 'apply',
        value: function apply(params) {
            return this.client.post('/v1/tickets/' + params.ticket_id + '/applicants');
        }

        /**
         * @api {put} /v1/tickets/:ticket_id/applicants bulkRemove
         * @apiGroup DoubleOptin
         * @apiName bulkRemove
         * @apiDescription Bulk remove doubleOptin applications for a ticket. Admin and above can withdraw others applications.
         * @apiParam {Number} ticket_id
         * @apiParam {Number[]} customer_ids
         * @apiExample {js} Example:
         *             gigwalk.doubleOptin.bulkRemove({...})
         */

    }, {
        key: 'bulkRemove',
        value: function bulkRemove(params) {
            var data = {
                action: 'remove',
                customer_ids: params.customer_ids
            };

            return this.client.put('/v1/tickets/' + params.ticket_id + '/applicants', data);
        }
    }]);
    return DoubleOptin;
}(_resource2.default);

exports.default = DoubleOptin;
//# sourceMappingURL=index.js.map